import React from 'react';
import { Radio, Tooltip } from 'antd';

const StateSwitch = ({ onSwitch = () => {}, value = 0 }) => {
  const icon = <span className="appkiticon icon-information-fill" />;
  const onChange = (e) => {
    if (e.target.value === value) {
      return;
    }
    onSwitch(e.target.value);
  };
  return (
    <div className="state-switch">
      <Radio.Group onChange={onChange} value={value} buttonStyle="solid">
        <Radio.Button value={0}>
          Current State
          <Tooltip
            title="View the current legal entity landscape for the company"
            overlayClassName="div-12point5rem-width"
            placement="bottom"
          >
            {icon}
          </Tooltip>
        </Radio.Button>
        <Radio.Button value={1}>
          Future State
          <Tooltip
            title={`Create a future state view by importing data into M&A Gateway, modeling changes to the legal entity landscape. Click "Future State" or click the expanded view button to begin the modeling process.`}
            overlayClassName="adjust-tooltip-index"
            placement="bottom"
          >
            {icon}
          </Tooltip>
        </Radio.Button>
      </Radio.Group>
    </div>
  );
};

export default StateSwitch;
